import { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import { useRouter } from 'next/router';

import { DISTRIBUTOR } from '@autopass-web/domain';
import { loadJson } from '@autopass-web/domain';

import { DIST, PATH } from '../../config';
import useAppStore from '../../pages/use-app';
import amplitude from '../../service/amplitude';
import { getLoginState } from '../../utils/login-state';
import styles from './index.module.sass';

const tabsGroup = {
  main: {
    icon: '/assets/tab-main.svg',
    iconActive: '/json/tab-main.json',
    name: '行車錢包',
    link: PATH.MAIN,
    amplitudeEvent: amplitude.tab_main_onClick,
  },
  maps: {
    icon: '/assets/tab-map.svg',
    iconActive: '/json/tab-maps.json',
    name: '場站地圖',
    link: PATH.MAPS,
    amplitudeEvent: amplitude.tab_maps_onClick,
  },
  orders: {
    icon: '/assets/tab-orders.svg',
    iconActive: '/json/tab-orders.json',
    name: '消費紀錄',
    link: PATH.ORDERS,
    amplitudeEvent: amplitude.tab_orders_onClick,
  },
  coins: {
    icon: '/assets/tab-points.svg',
    iconActive: '/json/tab-coins.json',
    name: '行車幣',
    link: PATH.COINS,
    amplitudeEvent: amplitude.tab_coins_onClick,
  },
};

const NavBottom = () => {
  const setTab = () => {
    const path = router.asPath;

    if (path.includes(PATH.COINS)) return 'coins';
    if (path.includes(PATH.MAPS)) return 'maps';
    if (path.includes(PATH.ORDERS)) return 'orders';
    return 'main';
  };

  const appStore = useAppStore();
  const tabs = appStore.distributor.params.bottomTabs;
  const isUser = getLoginState() === 'user';
  const isLineBank = DIST === DISTRIBUTOR.LINE_BANK;
  const router = useRouter();
  const [currentTab, setCurrentTab] = useState(setTab());
  const [tabsContent, setTabsContent] = useState([]);

  const exceptionPath = ['user', 'expired'];

  useEffect(() => {
    setCurrentTab(setTab());
  }, [router.asPath]); // eslint-disable-line

  useEffect(() => {
    const initTabsContent = async () => {
      let result = await Promise.all(
        tabs.map(async (tab) => {
          const tabContent = tabsGroup[tab];
          return {
            ...tabContent,
            id: tab,
            iconActive: await loadJson(tabContent.iconActive),
          };
        }),
      );

      setTabsContent(result);
    };

    initTabsContent();
    // eslint-disable-next-line
  }, []);

  if (exceptionPath.find((path) => router.asPath.includes(path))) return <></>;

  return (
    <ul className={styles['nav-bottom']}>
      {tabsContent.map((tab) => {
        const isActive = currentTab === tab.id;

        return (
          <li
            className={isActive ? `${styles.active}` : ''}
            key={tab.id}
            onClick={() => {
              tab.amplitudeEvent();
              if (tab.id === 'orders' || tab.id === 'coins') {
                if (isUser) {
                  router.push(tab.link);
                } else {
                  if (isLineBank) appStore.toggleLineBankLoginDialog();
                  appStore.setToastMessage('請先登入再繼續');
                  router.push(PATH.USER_LOGIN);
                }
              } else {
                router.push(tab.link);
              }
            }}
          >
            <span className={styles['icon-container']}>
              {isActive ? (
                <Lottie
                  width={23}
                  height={23}
                  options={{
                    loop: false,
                    animationData: tab.iconActive,
                  }}
                />
              ) : (
                // eslint-disable-next-line
                <img src={tab.icon} alt="icon" />
              )}
            </span>
            <span>{tab.name}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default NavBottom;
